import { authHeader } from '../helpers';

const getByMonth = async (year: number, month: number) => {
  const requestOptions = {
    method: 'GET',
    headers: {...authHeader(), "ngrok-skip-browser-warning": "69420"},
  };

  // Thêm `year` và `month` vào đường dẫn API
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/attendance_student_records/${year}/${month}`, requestOptions);
  return handleResponse(response);
};

const getByMonthsAndStudent = async (months: string[], studentId: number) => {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), "ngrok-skip-browser-warning": "69420" },
  };

  // months dạng ["2025-08","2025-09","2025-10"]
  const query = `months=${months.join(',')}&studentId=${studentId}`;
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/attendance_student_records/by-months-student?${query}`,
    requestOptions
  );
  return handleResponse(response);
};

const getBySessionId = async (sessionId: number) => {
  const requestOptions = {
    method: 'GET',
    headers: {...authHeader(), "ngrok-skip-browser-warning": "69420"},
  };

  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/attendance_student_records/session/${sessionId}`, requestOptions);
  return handleResponse(response);
};

function handleResponse(response: any) {
  return response.text().then((text: string) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}

export const attendanceStudentRecordService = {
  getByMonth,
  getByMonthsAndStudent,
  getBySessionId,
};
